import { SbDeviceListColumn } from '../../../services/global/global-interfaces';
import { ss_nm_Device_retrieveAll_filter, ss_nm_Device_retrieveAll_order } from '../../../services/api/api';

export const clientColumnDefaultsDevices: Record<string, SbDeviceListColumn[]> = {
  pmg: [
    // SELECTED START
    {
      id: 'id',
      title: 'ID',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.ID,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.ID,
      canFilter: true,
    },
    { id: 'lastIP', title: 'IP', selected: true, type: 'PROPERTY', canOrder: false },
    {
      id: 'productive',
      title: 'Productive',
      selected: true,

      type: 'PROPERTY',
      canOrder: false,
    },
    {
      id: 'offline',
      title: 'Offline',
      selected: true,

      type: 'PROPERTY',
      canOrder: false,
    },
    {
      id: 'disabled',
      title: 'Disabled',
      selected: true,

      type: 'PROPERTY',
      canOrder: false,
    },
    { id: 'pool', title: 'Pool', selected: true, type: 'PROPERTY', canOrder: false },
    {
      id: 'channel',
      title: 'Channel',
      selected: true,

      type: 'PROPERTY',
      canOrder: false,
    },
    {
      id: 'location',
      title: 'Location',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_ID,
      canOrder: true,
    },
    { id: 'CustStatus', title: 'CustStatus', selected: true, type: 'COMPANY_ATTRIBUTE' },
    {
      id: 'CustSapKeyOfn',
      title: 'SAP-CustNr',
      selected: true,

      type: 'COMPANY_ATTRIBUTE',
    },
    { id: 'CustName', title: 'CustName', selected: true, type: 'COMPANY_ATTRIBUTE' },
    {
      id: 'location.address.city',
      title: 'location.address.city',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_CITY,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_CITY,
      canFilter: true,
    },
    {
      id: 'location.address.street',
      title: 'location.address.street',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_STREET,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_STREET,
      canFilter: true,
    },
    {
      id: 'ParentCustSapKey',
      title: 'SAP-ParentCustNr',
      selected: true,

      type: 'COMPANY_ATTRIBUTE',
    },
    {
      id: 'ParentCustName',
      title: 'SAP-ParentCustName',
      selected: true,

      type: 'COMPANY_ATTRIBUTE',
    },
    // SELECTED END
    {
      id: 'location.id',
      title: 'location.id',
      selected: false,
      type: 'PROPERTY',
    },
    {
      id: 'identifier',
      title: 'lang.globals.identifier',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.IDENTIFIER,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.IDENTIFIER,
      canFilter: true,
    },
    {
      id: 'name',
      title: 'name',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.NAME,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.NAME,
      canFilter: true,
    },
    {
      id: 'location.created',
      title: 'location.created',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_CREATED_AT,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_CREATED_AT,
      canFilter: true,
    },
    {
      id: 'location.identifier',
      title: 'location.identifier',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_IDENTIFIER,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_IDENTIFIER,
      canFilter: true,
    },
    {
      id: 'location.name',
      title: 'location.name',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_NAME,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_NAME,
      canFilter: true,
    },
    {
      id: 'location.address',
      title: 'location.address',
      selected: false,

      type: 'PROPERTY',
      canOrder: false,
    },
    {
      id: 'location.address.borough',
      title: 'location.address.borough',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_BOROUGH,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_BOROUGH,
      canFilter: true,
    },
    {
      id: 'location.address.country',
      title: 'location.address.country',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_COUNTRY,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_COUNTRY,
      canFilter: true,
    },
    {
      id: 'location.address.county',
      title: 'location.address.county',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_COUNTY,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_COUNTY,
      canFilter: true,
    },
    {
      id: 'location.address.state',
      title: 'location.address.state',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_STATE,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_STATE,
      canFilter: true,
    },
    {
      id: 'location.address.street2',
      title: 'location.address.street2',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_STREET2,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_STREET2,
      canFilter: true,
    },
    {
      id: 'location.address.zip',
      title: 'location.address.zip',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_ZIP,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_ZIP,
      canFilter: true,
    },
    {
      id: 'location.managedBy.created',
      title: 'location.managedBy.created',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_CREATED_AT,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_CREATED_AT,
      canFilter: true,
    },
    {
      id: 'location.managedBy.identifier',
      title: 'location.managedBy.identifier',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_IDENTIFIER,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_IDENTIFIER,
      canFilter: true,
    },
    {
      id: 'location.managedBy.name',
      title: 'location.managedBy.name',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_NAME,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_NAME,
      canFilter: true,
    },
    {
      id: 'location.managedBy.address',
      title: 'location.managedBy.address',
      selected: false,

      type: 'PROPERTY',
      canOrder: false,
    },
    {
      id: 'location.managedBy.address.borough',
      title: 'location.managedBy.address.borough',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_BOROUGH,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_BOROUGH,
      canFilter: true,
    },
    {
      id: 'location.managedBy.address.city',
      title: 'location.managedBy.address.city',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_CITY,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_CITY,
      canFilter: true,
    },
    {
      id: 'location.managedBy.address.country',
      title: 'location.managedBy.address.country',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_COUNTRY,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_COUNTRY,
      canFilter: true,
    },
    {
      id: 'location.managedBy.address.county',
      title: 'location.managedBy.address.county',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_COUNTY,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_COUNTY,
      canFilter: true,
    },
    {
      id: 'location.managedBy.address.state',
      title: 'location.managedBy.address.state',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_STATE,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_STATE,
      canFilter: true,
    },
    {
      id: 'location.managedBy.address.street',
      title: 'location.managedBy.address.street',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_STREET,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_STREET,
      canFilter: true,
    },
    {
      id: 'location.managedBy.address.street2',
      title: 'location.managedBy.address.street2',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_STREET2,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_STREET2,
      canFilter: true,
    },
    {
      id: 'location.managedBy.address.zip',
      title: 'location.managedBy.address.zip',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_ZIP,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_ZIP,
      canFilter: true,
    },
  ],
  generic: [
    {
      id: 'id',
      title: 'ID',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.ID,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.ID,
      canFilter: true,
    },
    { id: 'lastIP', title: 'IP', selected: true, type: 'PROPERTY', canOrder: false },
    {
      id: 'productive',
      title: 'Productive',
      selected: true,

      type: 'PROPERTY',
      canOrder: false,
    },
    { id: 'pool', title: 'Pool', selected: true, type: 'PROPERTY', canOrder: false },
    {
      id: 'channel',
      title: 'Channel',
      selected: true,

      type: 'PROPERTY',
      canOrder: false,
    },
    {
      id: 'identifier',
      title: 'lang.globals.identifier',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.IDENTIFIER,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.IDENTIFIER,
      canFilter: true,
    },
    {
      id: 'name',
      title: 'name',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.NAME,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.NAME,
      canFilter: true,
    },
    {
      id: 'location.id',
      title: 'location.id',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_ID,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_ID,
      canFilter: true,
    },
    {
      id: 'location.created',
      title: 'location.created',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_CREATED_AT,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_CREATED_AT,
      canFilter: true,
    },
    {
      id: 'location.identifier',
      title: 'location.identifier',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_IDENTIFIER,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_IDENTIFIER,
      canFilter: true,
    },
    {
      id: 'location.name',
      title: 'location.name',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_NAME,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_NAME,
      canFilter: true,
    },
    {
      id: 'location.address',
      title: 'location.address',
      selected: false,

      type: 'PROPERTY',
      canOrder: false,
    },
    {
      id: 'location.address.borough',
      title: 'location.address.borough',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_BOROUGH,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_BOROUGH,
      canFilter: true,
    },
    {
      id: 'location.address.city',
      title: 'location.address.city',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_CITY,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_CITY,
      canFilter: true,
    },
    {
      id: 'location.address.country',
      title: 'location.address.country',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_COUNTRY,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_COUNTRY,
      canFilter: true,
    },
    {
      id: 'location.address.county',
      title: 'location.address.county',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_COUNTY,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_COUNTY,
      canFilter: true,
    },
    {
      id: 'location.address.state',
      title: 'location.address.state',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_STATE,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_STATE,
      canFilter: true,
    },
    {
      id: 'location.address.street',
      title: 'location.address.street',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_STREET,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_STREET,
      canFilter: true,
    },
    {
      id: 'location.address.street2',
      title: 'location.address.street2',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_STREET2,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_STREET2,
      canFilter: true,
    },
    {
      id: 'location.address.zip',
      title: 'location.address.zip',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_ZIP,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_ZIP,
      canFilter: true,
    },
    {
      id: 'location.managedBy.created',
      title: 'location.managedBy.created',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_CREATED_AT,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_CREATED_AT,
      canFilter: true,
    },
    {
      id: 'location.managedBy.identifier',
      title: 'location.managedBy.identifier',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_IDENTIFIER,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_IDENTIFIER,
      canFilter: true,
    },
    {
      id: 'location.managedBy.name',
      title: 'location.managedBy.name',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_NAME,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_NAME,
      canFilter: true,
    },
    {
      id: 'location.managedBy.address',
      title: 'location.managedBy.address',
      selected: false,

      type: 'PROPERTY',
      canOrder: false,
    },
    {
      id: 'location.managedBy.address.borough',
      title: 'location.managedBy.address.borough',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_BOROUGH,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_BOROUGH,
      canFilter: true,
    },
    {
      id: 'location.managedBy.address.city',
      title: 'location.managedBy.address.city',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_CITY,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_CITY,
      canFilter: true,
    },
    {
      id: 'location.managedBy.address.country',
      title: 'location.managedBy.address.country',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_COUNTRY,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_COUNTRY,
      canFilter: true,
    },
    {
      id: 'location.managedBy.address.county',
      title: 'location.managedBy.address.county',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_COUNTY,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_COUNTY,
      canFilter: true,
    },
    {
      id: 'location.managedBy.address.state',
      title: 'location.managedBy.address.state',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_STATE,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_STATE,
      canFilter: true,
    },
    {
      id: 'location.managedBy.address.street',
      title: 'location.managedBy.address.street',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_STREET,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_STREET,
      canFilter: true,
    },
    {
      id: 'location.managedBy.address.street2',
      title: 'location.managedBy.address.street2',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_STREET2,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_STREET2,
      canFilter: true,
    },
    {
      id: 'location.managedBy.address.zip',
      title: 'location.managedBy.address.zip',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.LOCATION_MANAGED_BY_ZIP,
      canOrder: true,
      filterId: ss_nm_Device_retrieveAll_filter.LOCATION_MANAGED_BY_ZIP,
      canFilter: true,
    },
    {
      id: 'positionUpdated',
      title: 'PositionUpdated',
      selected: false,
      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.POSITION_UPDATED,
      canOrder: true,
    },
    {
      id: 'serviceRequest',
      title: 'serviceRequest',
      selected: false,
      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.SERVICE_REQUEST_CREATED_AT,
      canOrder: true,
    },
    {
      id: 'serviceFulfilled',
      title: 'serviceFulfilled',
      selected: false,
      type: 'PROPERTY',
      orderId: ss_nm_Device_retrieveAll_order.SERVICE_FULFILLED_CREATED_AT,
      canOrder: true,
    },
  ],
};
